import React from 'react';
import { ArrowRight, PinIcon } from '../icons';
import { LOCS, CURRENT_CAMPUS } from '../data/constants';

const Locations = ({ t, currentCampus = CURRENT_CAMPUS }) => {
  // Ensure the school whose website is currently being viewed always appears first in the list
  const sortedLocs = [...LOCS].sort((a, b) => {
    if (a.id === currentCampus) return -1;
    if (b.id === currentCampus) return 1;
    return 0;
  });

  return (
    /* full-width paper bg */
    <div className="w-full bg-paper">
      {/* max-width content */}
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] min-h-[700px] py-20 box-border flex flex-col justify-center gap-[44px]">
        {/* Heading block */}
        <div className="flex flex-col gap-3">
          <h2 className="m-0 font-heading font-medium text-[46px] leading-[1.1] text-navy tracking-[-0.015em] uppercase">
            {t.locTitle}
          </h2>
          <p className="m-0 text-[17px] text-muted">{t.locSub}</p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sortedLocs.map((loc) => {
            const isCurrent = loc.id === currentCampus;
            const targetUrl = isCurrent ? loc.mapsUrl : loc.url;
            const actionText = isCurrent
              ? t.openInMaps || 'Open in Maps'
              : t.visitSite || 'Visit Website';

            return (
              <a
                key={loc.id || loc.name}
                className="loc flex flex-col bg-white border border-line rounded-[8px] overflow-hidden hover:shadow-xl transition-all duration-300 group"
                href={targetUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* Image */}
                <div
                  className="relative h-[250px]"
                  style={{ background: 'linear-gradient(135deg, #dbe8f0 0%, #b8d0e0 100%)' }}
                >
                  <img
                    src={loc.image}
                    alt={loc.name}
                    className="absolute inset-0 w-full h-full object-cover block group-hover:scale-105 transition-transform duration-500"
                  />

                  {/* Region badge */}
                  <span className="absolute left-0 top-5 flex items-center gap-2 h-8 px-4 bg-navy text-white text-[11.5px] font-bold tracking-[0.12em] uppercase">
                    <PinIcon /> {loc.region}
                  </span>
                </div>

                {/* Card body */}
                <div className="px-7 pt-[26px] pb-6 flex flex-col gap-1 items-start w-full box-border">
                  <img src={loc.logo} alt={loc.name} className="h-14 w-auto mb-2" />
                  <span className="text-[14.5px] text-muted">{loc.domain}</span>
                  <div className="flex items-center justify-between w-full mt-[22px] pt-4 border-t border-line text-[12.5px] font-bold tracking-widest uppercase text-navy group-hover:text-gold transition-colors">
                    <span>{actionText}</span>
                    <ArrowRight className="arr transform transition-transform group-hover:translate-x-1" size={18} />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Locations;
